// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1CoN_","main-image":"Header_main-image__1wkpm"};